module.exports = __webpack_public_path__ + "static/media/ai2html-graphic-desktop.3bb257bb.mp4";